import React, { Fragment, useEffect } from 'react';

import { map, get, isArray, isEmpty, remove, cloneDeep } from 'lodash';
import classNames from 'classnames';

// local dependencies
import { Icon } from 'modules/icon-bank';
import moment from 'moment';


/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { flyoutMessage as FlyoutMessage } from 'ui/views/generic/flyoutMessage';
 *
 * // render
 * <FlyoutMessage propName='propValue'/>
 */
export const flyoutMessage = ( props ) => {

    const { isOpen, widgets, onCloseClick, appContext } = props;

    const flyoutClassName = classNames( 'ui-flyout-message', {
        'ui-flyout-message--open': isOpen
    } );

    const epostId = get( appContext, 'component.data.state.authorization.ePostId', ''  );

    const _widgets = remove( cloneDeep( widgets ), ( widget ) => { return !widget.updated; } );

    useEffect( () => {

        if( isArray( _widgets ) && isEmpty( _widgets ) ) {
            return () => {
                clearTimeout( timer1 );
            };
        }

        // set `isActive` to `true` if the child element is overflowing
        const timer1 = setTimeout( () => onCloseClick(), 6000 );

        return () => {
            clearTimeout( timer1 );
        };
    } );

    if( isArray( _widgets ) && isEmpty( _widgets ) ) {
        return null;
    }

    return (
        <div className={ flyoutClassName }>
            <div className='ui-flyout-message__head'>
                <div className='ui-flyout-message__head__title'>
                    Hi { epostId }
                </div>
                <div className='ui-flyout-message__head__close' onClick={ onCloseClick }>
                    <Icon name='close' width='10' height='10' fill='#2d2d2d' />
                </div>
            </div>
            <div className='ui-flyout-message__body'>
                <div className='ui-flyout-message__body__widgets'>
                    {
                        map( widgets, widget => {
                            const widgetId = widget.id;
                            const widgetClassName = classNames( 'ui-flyout-message__body__widgets__widget', {
                                'ui-flyout-message__body__widgets__widget--updated': widget.updated
                            } );

                            if( !widget.updated ) {
                                return null;
                            }

                            return (
                                <Fragment>
                                    <div key={ widgetId } className={ widgetClassName }>
                                        <em className='ui-flyout-message__body__widgets__widget__message'> Alerts were Updated </em>
                                        <div className='ui-flyout-message__body__widgets__widget__time'>{ moment( widget.timeStamp ).format( 'HH:mm A' ) } </div>
                                    </div>
                                </Fragment>
                            );
                        } )
                    }
                </div>
            </div>
        </div>
    );
};

// set display name
flyoutMessage.displayName = 'flyoutMessage';

// set default props
flyoutMessage.defaultProps = {};

// prop types
flyoutMessage.propTypes = {};
